module.exports = __webpack_public_path__ + "img/medical_medicine_children.97470be4.jpg";